var map = {
	"./analytics/store/analytics.store.ts": 1366,
	"./article/store/article.store.ts": 1367,
	"./category/store/category.store.ts": 1368,
	"./customer/store/bookmarks.store.ts": 1369,
	"./frontpage/store/frontpage.store.ts": 1370,
	"./navigation/store/navigation.store.ts": 1371,
	"./podcast/store/podcast.store.ts": 1372,
	"./weather/store/weather.store.ts": 1396
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1365;